import React from 'react';
import { get } from 'lodash';
import { useBexApi } from '@shared-ui/bex-api-context';
import { UitkTab, UitkTabs, UitkTabsType } from 'uitk-react-tabs';
import { Layout } from '../modules/layout/layout';
import { Activity } from './shareduiwizard/Activity/Activity';
import { LogdingUitk } from './shareduiwizard/Lodging/logdingUitk';
import { Cars } from './shareduiwizard/cars/cars';
import { css } from 'styled-components';
import { PackagesUitk } from './shareduiwizard/packages/packagesUitk';
import { checkValue, appendMcicid, LightenDarkenColor, ItemKeyHelper } from '../helper';
import { FlightUitk } from './shareduiwizard/flights/flightUitk';
import { useStores } from 'src/utils/useStore';
import { Cruise } from './shareduiwizard/cruise/Cruise';
import { SearchWizardProps } from 'src/utils/module-util';
import { Typo } from '../ui';

const SearchWizard: React.FC<SearchWizardProps> = (props) => {
  const {
    cpcmslitefeed: { cpCmsLitePageData, spotlightPageData, conciergePageData },
    context: useContext,
  } = useStores();
  
  // const [searchFilters, setSearchFilters]: [any, React.Dispatch<React.SetStateAction<any>>] = React.useState({});

  const moduleItemref = new ItemKeyHelper('search-wizard-tab');

  const primaryColour = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData?.primaryColour
    : checkValue(spotlightPageData)
    ? spotlightPageData?.primaryColour
    : checkValue(conciergePageData)
    ? conciergePageData?.primaryColor
    : '';
  const modulCTAtBGColor = checkValue(props.data.cTAColor) ? props.data.cTAColor : '';
  const modulCTAtxtColor = checkValue(props.data.cTATextColor) ? props.data.cTATextColor : '';
  const moduleTextColor = checkValue(props?.data?.moduleTextColor) ? props?.data?.moduleTextColor : '';
  const { context } = useBexApi();

  let wizardTabs =
    checkValue(get(props, 'data.wizardTabs', [])) && get(props, 'data.wizardTabs', []).length > 0
      ? get(props, 'data.wizardTabs', [])
      : [];

  // If vrbo active only hotel search wizard
  if (useContext?.site?.brand === 'vrbo' || useContext?.site?.brand === 'hotels' ) {
    wizardTabs = wizardTabs.filter((tab: string) => tab?.toLowerCase() === 'hotel');
  }

  const defaultTabIndex = checkValue(props.data.defaultTab)
    ? wizardTabs.findIndex((tab) => tab === props.data.defaultTab)
    : 0;
  const [selectedTab, setSelectedTab] = React.useState(defaultTabIndex);

  const handleTabSelect = (currentTabIndex: number): void => {
    
    if (typeof currentTabIndex !== 'number') {
      return;
    }
    props?.setActiveTab && props?.setActiveTab(wizardTabs[currentTabIndex]);
    setSelectedTab(currentTabIndex);
  };

  const getTabCopy = (tab, dValue) => {
    return context?.device?.type === 'DESKTOP'
      ? get(props, `wizardLocalization.[${tab}].tab_copy`, dValue)
      : get(props, `wizardLocalization.[${tab}].mobile.tab_copy`, dValue);
  };

  const loadTabs = (tabs, details, id) => {
    const wizardTabData = {
      mccidData: details?.mccidData,
      device: context?.device?.type,
      data: {...details?.data, isAdvanced: props?.isAdvanced}
    };

    const commonLocalization = {
      date_picker_select: details?.wizardLocalization?.date_picker_select,
      select_destination: details?.wizardLocalization?.select_destination,
      select_origin: details?.wizardLocalization?.select_origin,
      select_origin_or_airport: details?.wizardLocalization?.select_origin_or_airport,
    };

    switch (tabs) {
      case 'Hotel':
        return (
          <UitkTab key={moduleItemref.next()} name={getTabCopy('hotels', 'Stays')} targetURI="#" tabLinkAttr={{ id: id }}>
            <div className="tab-content-wrapper">
              <LogdingUitk
                {...{
                  ...wizardTabData,
                  localizationData: {
                    ...details?.wizardLocalization?.hotels,
                    ...commonLocalization,
                    ['mobile']: { ...details?.wizardLocalization?.hotels?.mobile, ...commonLocalization },
                  },
                }}
                isAdvanced={props?.isAdvanced}
                setSearchFilters={props?.setSearchFilters}
              />
            </div>
          </UitkTab>
        );

      case 'Flight':
        return (
          <UitkTab key={moduleItemref.next()} name={getTabCopy('flights', 'Flights')} targetURI="#" tabLinkAttr={{ id: id }}>
            <div className="tab-content-wrapper">
              <FlightUitk
                {...{
                  ...wizardTabData,
                  localizationData: {
                    ...details?.wizardLocalization?.flights,
                    ...commonLocalization,
                    ['mobile']: { ...details?.wizardLocalization?.flights?.mobile, ...commonLocalization },
                  },
                }}
                isAdvanced={props?.isAdvanced}
                setSearchFilters={props?.setSearchFilters}
              />
            </div>
          </UitkTab>
        );

      case 'Package':
        return (
          <UitkTab key={moduleItemref.next()} name={getTabCopy('packages', 'Packages')} targetURI="#" tabLinkAttr={{ id: id }}>
            <div className="tab-content-wrapper">
              <PackagesUitk
                {...{
                  ...wizardTabData,
                  localizationData: {
                    ...details?.wizardLocalization?.packages,
                    ...commonLocalization,
                    ['mobile']: { ...details?.wizardLocalization?.packages?.mobile, ...commonLocalization },
                  },
                }}
              />
            </div>
          </UitkTab>
        );
      case 'Activities':
        return (
          <UitkTab key={moduleItemref.next()} name={getTabCopy('activities', 'Activities')} targetURI="#" tabLinkAttr={{ id: id }}>
            <div className="tab-content-wrapper">
              <Activity
                {...{
                  ...wizardTabData,
                  localizationData: {
                    ...details?.wizardLocalization?.activities,
                    ...commonLocalization,
                    ['mobile']: { ...details?.wizardLocalization?.activities?.mobile, ...commonLocalization },
                  },
                }}
              />
            </div>
          </UitkTab>
        );
      case 'Car':
        return (
          <UitkTab key={moduleItemref.next()} name={getTabCopy('car', 'Cars')} targetURI="#" tabLinkAttr={{ id: id }}>
            <div className="tab-content-wrapper">
              <Cars
                {...{
                  ...wizardTabData,
                  localizationData: {
                    ...details?.wizardLocalization?.car,
                    ...commonLocalization,
                    ['mobile']: { ...details?.wizardLocalization?.car?.mobile, ...commonLocalization },
                  },
                }}
              />
            </div>
          </UitkTab>
        );

      case 'Cruise':
        return (
          <UitkTab key={moduleItemref.next()} name={getTabCopy('cruise', 'Cruises')} targetURI="#" tabLinkAttr={{ id: id }}>
            <div className="tab-content-wrapper">
              <Cruise
                {...{
                  ...wizardTabData,
                  localizationData: {
                    ...details?.wizardLocalization?.cruises,
                    ...commonLocalization,
                    ['mobile']: { ...details?.wizardLocalization?.cruises?.mobile, ...commonLocalization },
                  },
                }}
              />
            </div>
          </UitkTab>
        );

      default:
        return null;
    }
  };

  const moduleCss = () => {
    const buttonHoverColor = checkValue(modulCTAtBGColor) ? LightenDarkenColor(modulCTAtBGColor, -0.1) : '';
    const ctaHoverBgColor = checkValue(props?.data?.ctaHoverColor) ? props?.data?.ctaHoverColor : buttonHoverColor
    const ctaHoverTextColor = checkValue(props?.data?.ctaHoverTextColor) ? props?.data?.ctaHoverTextColor : modulCTAtxtColor
    
    if (checkValue(primaryColour) && checkValue(props.cssOverrideByPrimaryColor) && props.cssOverrideByPrimaryColor) {
      const darkenColor = checkValue(primaryColour) ? LightenDarkenColor(primaryColour, -0.1) : '';
      return `
          ${`
                .uitk-tab-anchor-selected {
                  color: ${primaryColour} !important;
                }
                .uitk-tab-highlighter {

                  background: ${primaryColour} !important;
                }
                .uitk-button-primary {
                  background-color: ${primaryColour} !important;
                } 
                .uitk-button-primary:hover {
                  background-color: ${darkenColor} !important;
                }
                ${
                  checkValue(moduleTextColor)
                    ? `
                    .booking-widget h2.cms-typo {
                      color : ${moduleTextColor} !important;
                    }
                `
                    : ''
                }
                
                    .wizard-search-button-container{
                      .uitk-button-primary{
                        color: ${modulCTAtxtColor} !important;
                        background-color: ${modulCTAtBGColor} !important;
                        border-color: ${modulCTAtBGColor} !important;
                      }
                      .uitk-button-primary:hover{
                        background-color: ${ctaHoverBgColor} !important;
                        border-color: ${ctaHoverBgColor} !important;
                        color: ${ctaHoverTextColor} !important;
                      }
                    }
                  
                
              `}
        `;
    } else {
      return `
      .booking-widget{
        .uitk-date-picker-menu-container{
          .uitk-button-primary{
            color: ${modulCTAtxtColor} !important;
            background-color: ${modulCTAtBGColor} !important;
          }
        }
        .wizard-search-button-container{
          .uitk-button-primary{
            color: ${modulCTAtxtColor} !important;
            background-color: ${modulCTAtBGColor} !important;
            border-color: ${modulCTAtBGColor} !important;
          }
          .uitk-button-primary:hover{
            background-color: ${ctaHoverBgColor} !important;
            border-color: ${ctaHoverBgColor} !important;
            color: ${ctaHoverTextColor} !important;
          }
        }
      }
      
      ${
        checkValue(moduleTextColor)
          ? `
      .booking-widget h2.cms-typo {
        color : ${moduleTextColor} !important;
      }
  `
          : ''
      }
      ${props?.defaultSetting?.style?.bodyFont === "Reckless Neue" ? `
      .booking-widget h2.cms-typo {
        font-weight:300 !important;
      }
      ` : ``}
 
      .wizard-search-button-container{
        .uitk-button-primary{
          color: ${modulCTAtxtColor} !important;
          background-color: ${modulCTAtBGColor} !important;
          border-color: ${modulCTAtBGColor} !important;
        }
        .uitk-button-primary:hover{
          background-color: ${ctaHoverBgColor} !important;
          border-color: ${ctaHoverBgColor} !important;
          color: ${ctaHoverTextColor} !important;
        }
      }
    
  
      `;
    }
  };
  const wizardTitle = checkValue(get(props, 'data.title', 'Plan your trip'))
    ? get(props, 'data.title', 'Plan your trip')
    : '';
  return (
    <>
      {checkValue(wizardTabs) && wizardTabs.length > 0 && (
        <Layout
          className="booking-section"
          css={css`
            ${moduleCss()}
          `}
          id="search-booking-wizard-module"
        >
          <div className="booking-widget">
            <div className={`container ${!checkValue(wizardTitle) ? 'no-wizard-title' : ''}`}>
              {checkValue(wizardTitle) && <Typo.HTMLText tag="h2" exClass={`override-heading-font-family`}>{wizardTitle}</Typo.HTMLText>}
              {checkValue(props.data.subTitle) && <Typo.HTMLText tag="p" exClass={`override-heading-font-family`}>{props.data?.subTitle}</Typo.HTMLText>}
              <div className="search-tab-wrapper">
                <UitkTabs selectedTab={selectedTab} onTabSelect={handleTabSelect} tabsType={UitkTabsType.NATURAL}>
                  {wizardTabs.map((tab, index) => loadTabs(tab, props, `Tab-${index + 1}`))}
                </UitkTabs>
              </div>
            </div>
          </div>
        </Layout>
      )}
    </>
  );
};

export default SearchWizard;

export const linkTabOpenner = (url, mccidData) => {
  const mcicidUrl: string = appendMcicid(
    url,
    mccidData?.templateType,
    mccidData?.campaignUrl,
    mccidData?.mainUrl,
    mccidData?.referrerId,
    mccidData?.extraParam,
  );
  const a = document.createElement('a');
  a.target = '_blank';
  a.href = mcicidUrl;
  a.click();
};
